import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M14.745 6.462v2.63a.75.75 0 0 1-1.5 0v-2.63a2.078 2.078 0 0 0-2.08-2.08h-3.19a.75.75 0 0 1 0-1.5h3.19a3.576 3.576 0 0 1 3.58 3.58Zm-2.09 1.26v2.65a2.748 2.748 0 0 1-2.75 2.75H4a2.748 2.748 0 0 1-2.75-2.75v-2.65A2.748 2.748 0 0 1 4 4.972h5.9a2.748 2.748 0 0 1 2.755 2.75Zm-1.5 0A1.25 1.25 0 0 0 9.9 6.472H4a1.25 1.25 0 0 0-1.25 1.25v2.65A1.25 1.25 0 0 0 4 11.622h5.9a1.25 1.25 0 0 0 1.25-1.25Zm-4.21-.26a1.585 1.585 0 1 0 1.59 1.58 1.583 1.583 0 0 0-1.59-1.58Z';
const draw24px = 'M15.88,18.94H5a2.75,2.75,0,0,1-2.75-2.75v-6A2.75,2.75,0,0,1,5,7.47H15.88a2.75,2.75,0,0,1,2.75,2.75v6A2.75,2.75,0,0,1,15.88,18.94ZM5,9a1.25,1.25,0,0,0-1.25,1.25v6A1.25,1.25,0,0,0,5,17.44H15.88a1.25,1.25,0,0,0,1.25-1.25v-6A1.25,1.25,0,0,0,15.88,9Zm16.74,5.8V9.33a5,5,0,0,0-5-5H6a.75.75,0,0,0,0,1.5H16.77a3.5,3.5,0,0,1,3.5,3.49v5.44a.75.75,0,0,0,1.5,0ZM10.46,10.83a2.38,2.38,0,1,0,2.37,2.38A2.38,2.38,0,0,0,10.46,10.83Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const MoneyIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'money'));
MoneyIcon.displayName = 'MoneyIcon';
MoneyIcon.propTypes = Icon.propTypes;
MoneyIcon.renderIcon = props => /*#__PURE__*/React.createElement(MoneyIcon, props);
export default MoneyIcon;
//# sourceMappingURL=MoneyIcon.js.map